import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import Dialog from 'scenes/Dialog';
import Popup from 'components/Popup';
import UxHelpers from 'helpers/ux-helpers.js';
import DialogQuestLayout from 'components/DialogQuestLayout';

const DeleteAccountRequestSecondStepDialog = (props) => {
  const { show, proceed, dismiss } = props;

  const onSuccess = (data) => {
    proceed(data);
    UxHelpers.overflowLock('unlock');
  };

  const body = (
    <Dialog dialogStyles={{ width: 600, marginBottom: '-20px' }} dialogCssClass={'delete-account-dialog'}>
      <DialogQuestLayout
        message="Before permanently removing your account, which situation fits you best?"
        titleLeft="Situation"
        titleRight="Recommendation"
        cases={[
          {
            title: 'I’m getting too many emails',
            action: () => {
              onSuccess(1)
            },
            buttonText: 'Unsubscribe from daily jobs notifications',
            helpText: 'You can receive a weekly jobs digest instead of daily / real time emails',
          }, {
            title: 'I’m off the job market',
            action: () => {
              onSuccess(2)
            },
            buttonText: 'Pause job related email for 6 months',
            helpText: 'You can pause job related emails for 6 months',
          }, {
            title: 'I want to leave the platform',
            action: () => {
              onSuccess(3)
            },
            buttonText: 'Leave the platform',
            helpText: 'We can remove your account',
          },
        ]}
      />
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{ dismiss }}
        bodyRender={body}
      />
    )
  );
};

export default createConfirmation(confirmable(DeleteAccountRequestSecondStepDialog));
